import React from 'react'
import { Spin } from 'antd'
import './index.less'

export default (props) => {
  const { wrapperClassName, ...otherProps } = props
  return <Spin
    indicator={<div className="meinian-loading-wrap"><div className="meinian-loading" /></div>}
    {...otherProps}
    wrapperClassName={`meinian-loading-spin ${wrapperClassName}`}
  >
    {props.children}
  </Spin>
}
